import { render, staticRenderFns } from "./ImageLoader.vue?vue&type=template&id=4584ffc2&scoped=true&"
import script from "./ImageLoader.vue?vue&type=script&lang=js&"
export * from "./ImageLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4584ffc2",
  null
  
)

export default component.exports